module.exports = __webpack_public_path__ + "media/images/help-icon-ab56af1ce77271ebb739155667eeb71a.png";